import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SweetAlertResult } from 'sweetalert2';

import { SharedService } from '@services/shared.service';
import { ApiTransactionService } from '@services/api-transaction.service';
import { ApiAccountService } from '@services/api-account.service';
import { ApiProductService } from '@services/api-product.service';

import { CustomerModel } from '@models/CustomerModel';
import { CustomerCardModel } from '@models/CardModel';
import { CardPaymentModel } from '@models/RegisterModel';
import { CardFormComponent } from '@components/card-form/card-form.component';
import { AppProductModel } from '@models/ProductModel';
import { BuyerType, TransactionModel, NewTransactionPointsModel, ProductOrderModel } from '@models/TransactionModel';
import { ProductTaxType, PayType, OrderStatus, PointTransactionType, CurrencyType, Country } from '@models/Enums';

import { ModalFormBase } from '@shared/modal-base.component';


@Component({
    selector: 'app-purchase-points-modal',
    templateUrl: './purchase-points-modal.component.html',
    styleUrls: ['./purchase-points-modal.component.scss']
})
export class PurchasePointsModalComponent extends ModalFormBase<NewTransactionPointsModel> implements OnInit {

    @Input() isButton = false;
    @Input() user: CustomerModel;


    @ViewChild('purchaseModal', { static: true }) modal: TemplateRef<any>;

    products: AppProductModel[] = [];

    model: NewTransactionPointsModel;

    // form


    selectedProduct = '';

    showSummary = false;

    methods: CustomerCardModel[] = [];
    currentMethod: CustomerCardModel;

    selectedMethod = '';

    // País de la sesión: define la pasarela con la que se agrega la tarjeta
    country: Country = Country.CR;

    newCard: CardPaymentModel;

    currencySymbol = '₡';


    constructor(
        private router: Router,
        public sharedService: SharedService,
        public modalService: NgbModal,
        private apiAccountService: ApiAccountService,
        private apiProductService: ApiProductService,
        private apiTransactionService: ApiTransactionService) {
        super(modalService);
    }

    ngOnInit(): void {

        this.country = this.apiTransactionService.getSession()?.user?.country ?? Country.CR;

        const session = this.apiTransactionService.getSession();

        if(session?.user?.country == Country.CR) this.currencySymbol = '₡';
        else if(session?.user?.country == Country.PA) this.currencySymbol = '$';

        this._getAppProducts();
        this._getPaymentMethods(false);
    }

    onOpen() {

        if (!this.user) {
            return this.sharedService.SwalCustom.fire({
                title: 'Iniciar sesión',
                text: 'Para comprar puntos debe iniciar sesión.',
                showCancelButton: true,

                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Iniciar sesión',

                allowOutsideClick: false,

                customClass: {
                    confirmButton: 'btn btn-modal-main',
                    cancelButton: 'btn btn-modal-second'
                },
                buttonsStyling: false
            }).then(
                (result: SweetAlertResult) => {

                    if (result && result.value) {

                        this.router.navigate(['login']);
                    }
                }
            );
        }

        this._getPaymentMethods();

        this.showSummary = false;
        this.model = null;

        this.selectedProduct = null;
        this.selectedMethod = null;

        super.open(this.modal, {
            backdrop: 'static', keyboard: false,
            windowClass: 'modal-dialog-end'
        });
    }

    onClose() {

        super.close();
    }

    // cuando se selecciona el paquete y va al resumen de pago
    onNext() {

        const product = this.products.find(x => x.id == parseInt(this.selectedProduct, 10));

        this.model = new NewTransactionPointsModel({
            buyerType: BuyerType.Customer,
            customerId: this.user.id,

            subTotal: product.price,
            taxTotal: 0, // No tiene IVA 
            total: product.price,

            points: product.points,

            products: [
                new ProductOrderModel({
                    productId: product.id,
                    sku: product.sku,
                    productName: product.name,
                    
                    quantity: 1,
                    points: product.points,
                    
                    price: product.allowDiscount ? product.priceWithDiscount : product.price,
                    tax: 0, // No tiene IVA 
                    taxType: ProductTaxType.Exempt,
                    taxPercent: 0,
                    // totalPrice: product.price
                    currencyType: CurrencyType.CRC,
                    // Precio proveedor
                    //vendorPrice: product.vendorPrice,
                    //vendorPriceWithTax: product.vendorPriceWithTax,
                    // Precio a Givi
                    //vendorDiscountType: product.vendorDiscountType,
                    //vendorPriceWithDiscount: product.vendorPriceWithDiscount,

                })
            ]
        });

        this._formInit();

        this.showSummary = true;
    }

    onSelectMethod(card: CustomerCardModel, modal: any) {

        this.currentMethod = card;
        modal.dismiss();
    }

    @ViewChild(CardFormComponent) cardFormComponent: CardFormComponent;

    // La tarjeta la arma app-card-form y llega por (cardChange). null = incompleta.
    onCardChange(card: CardPaymentModel) {

        this.newCard = card;
    }

    onSaveCard(modal: any): void {

        if (!this.newCard) return;

        this.newCard.companyId = this.user.id;

        if (this.cardFormComponent?.isAmexCVC) {

            const errMsg = 'No se aceptan tarjetas American Express. Por favor revisá la información y volvé a intentarlo.';
            this.sharedService.showErrorAlert(null, errMsg);
        }
        else {

            this.sharedService.setLoading(true);

            this.apiAccountService.addCard(this.newCard).then(
                (data: any) => {

                    this.sharedService.setLoading(false); // hide loader

                    this._getPaymentMethods();

                    this.sharedService.showSuccessAlert(
                        null, `La tarjeta fue agregada correctamente`
                    ).then(_ => modal.dismiss());
                },
                (err: any) => {
                    this.sharedService.setLoading(false); // hide loader

                    const errMsg = 'No se pudo agregar la tarjeta. Por favor revisá la información y volvé a intentarlo.';
                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    onCreateCard(paymentMethodModal: any) {

        this.newCard = null;

        this.modalService.open(paymentMethodModal, {
            backdrop: 'static', keyboard: false,
            windowClass: 'modal-dialog-end modal-full'
        });
    }

    onOpenMethods(paymentMethodModal: any) {

        this.modalService.open(paymentMethodModal, {
            backdrop: 'static', keyboard: false,
            windowClass: 'modal-dialog-end modal-full'
        });
    }

    onPay() {

        if (this.model && this.currentMethod) {

            this.model.cardToken = this.currentMethod.token;
            this.model.payType = PayType.Card;

            this.sharedService.setLoading(true);

            this.apiTransactionService.payOrderPoints(this.model).then(
                (transactionResult: any) => {
                    
                    this.apiTransactionService.loadAccount().then(
                        user => {
                            
                            this.sharedService.setLoading(false); // hide loader

                            this.sharedService.showSuccessAlert(
                                null, `La compra de puntos fue realizada correctamente`
                            ).then(_ => this.modalService.dismissAll());
                        },
                        err => {

                            this.sharedService.setLoading(false);
                        });
                },
                (err: any) => {
                    this.sharedService.setLoading(false);

                    let errMsg = '';

                    if (typeof err.error?.Message == "string" && err.error?.Message.length) {

                        errMsg = err.error?.Message;
                    }
                    else {
                        errMsg = 'No se pudo realizar la compra. Por favor revisá la información y volvé a intentarlo.';
                    }

                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );

        }
    }


    // Form

    private _formInit(): void {

        // Reset for hide form errors
        this.touched = true;
    }

    // End Form


    private _getAppProducts() {

        this.apiProductService.getAllAppProducts().then(
            (products: AppProductModel[]) => {

                this.products = products;
            }
        );
    }

    private _getPaymentMethods(showSpinner = true) {

        // No hacer la llamada si no esta logueado
        if (!this.user) return;

        if (showSpinner) this.sharedService.setLoading(true);

        return this.apiAccountService.getAllCards(this.user.id).then(
            (cards: CustomerCardModel[]) => {

                this.currentMethod = cards.find(x => x.isCurrent);
                if (this.currentMethod) {
                    this.selectedMethod = this.currentMethod.token;
                }

                this.methods = cards; // update the source

                if (showSpinner) this.sharedService.setLoading(false);
            },
            (err: any) => {

                if (showSpinner) this.sharedService.setLoading(false);
            }
        );
    }
}
